module.exports = __webpack_public_path__ + "static/img/gaw.aadbc15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/gaw.jpg
// module id = xJfb
// module chunks = 0